// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressAutocomplete_wrapper__pjkcA","flag":"AddressAutocomplete_flag__BkR2e","input":"AddressAutocomplete_input__wrFAo"};